import useCache from "@/common/hook/useCache";
import CacheKeys from "@/common/models/CacheKeys";

export default function useIsChatActive() {
  return useCache(CacheKeys.CHAT_ACTIVE);
}
